__turbopack_context__.v({
  "root": "ShowMore-module__UXJdoG__root",
});
